import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import {Auth} from '../components/Auth';
import logo from '../images/logo.jpg';

function Lhb(props) {
	if(props.loggedIn) {
		return <Link to="/" onClick={() => Auth.signout()} >Logout</Link>
	}else{
		return <Link to="/login">Login</Link>
	}
	//return <h1>Hello, {props.loggedIn}</h1>;
}



class Header extends Component {

	

  render() {
    return (
    	<div id="header">
    		
	      	<ul>
		  	{/*<img className='logo-image' src={logo} /> */}
		  		<li>
			      	<b>SALES-CHARTS</b>
			    </li>
			    <li>
			      	<Link to="/">Home</Link>
			    </li>
			    <li>
			      	<Link to="/import">Data Import</Link>
			    </li>
                <li>
			      	<Link to="/sales">Charts</Link>
			    </li>
                {/* <li>
			      	<Link to="/map">Map</Link>
			    </li>
                <li>
			      	<Link to="/survey">Survey</Link>
			    </li> */}
		 	</ul>
	  	</div>
    )
  }
}

export default Header;